export const PRE_ORDER_MARKER = 'data-pre-order-atc-button';
//export const ATC_SELECTOR_TYPE = 'pre-order_add_to_cart';

export default class AddToCart {
  /**
   *
   */
  #selectorType;

  /**
   * @type {Set<HTMLElement>}
   */
  #buttonsProcessed = new Set();

  /**
   * @param {string} selector
   * @param {string} page
   */
  constructor(selector, page) {
    const global = window.Spurit.global;
    this.#selectorType = page === 'products' ? global.constants.SELECTOR.PRODUCT_ADD_TO_CART : global.constants.SELECTOR.COLLECTION_ADD_TO_CART;
    global.selectors.add(selector, this.#selectorType);
    global.selectors.add(`[${PRE_ORDER_MARKER}]`, this.#selectorType);
  }

  /**
   * @param {function(HTMLElement)} callback
   */
  forEachButton(callback) {
    const global = window.Spurit.global;
    const processButtons = () => global.selectors.getTheHighestElements(this.#selectorType).forEach(button => {
      if (this.#buttonsProcessed.has(button)) {
        return;
      }
      this.#buttonsProcessed.add(button);
      callback(button);
    });
    processButtons();
    global.selectors.onElementsAppear(
        this.#selectorType,
        processButtons,
        global.constants.SELECTOR_ALGORITHM.HIGHEST
    );
  }

  /**
   * @param {HTMLElement} button
   * @return {boolean}
   */
  static shouldSkip(button) {
    return button.hasAttribute(PRE_ORDER_MARKER);
  }
}